<template>
    <div>
        <div class="page_tob_d">
           <div class="page_footer_wd">
            <div class="page_chat">
                <div>联系</div>
                <div class="chat_right">微信</div>
            </div>
            <div class="page_userPhone">
            <div class="page_size">
              <div class="page_de_mbt">
                  <div class="page_de_mbr">公司电话</div>
                 <div>+86 598412635</div>
             </div>
             <div>
                  <div class="page_de_mbr">公司地址</div>
                 <div>浙江省杭州市余杭区xx街道</div>
             </div>
            </div>
            <div class="page_size">
              <div class="page_de_mbt">
                  <div class="page_de_mbr">联系邮箱</div>
                 <div>dasenmini@163.com</div>
             </div>
             <div>
                  <div class="page_de_mbr">备案号</div>
                 <a href="https://beian.miit.gov.cn/" style="color: #fff;" target="_blank">浙ICP备20016782号-2</a>
                 <!-- <div>浙ICP备20016782号-2 </div> -->
             </div>
            </div>
            <div>
                <img class="page_image" src="../assets/code.png" />
            </div>
          </div>
            
           </div>
        </div>
    </div>

</template>
<script>
// import { postWebBusiness } from "@/api/api";
export default {
    data() {
        return {
            userName: '',
            userEmail: '',
            userPhone: '',
            index: false
        }
    },
    methods: {
        async addUserInfo() {
            if (this.userName == '') {
                return this.$message({
                    message: '请输入姓名后,重新提交',
                    type: 'error'
                });
            }
            if (this.userEmail == '') {
                return this.$message({
                    message: '请输入邮箱后,重新提交',
                    type: 'error'
                });
            }
            if (this.userPhone == '') {
                return this.$message({
                    message: '请输入手机号后,重新提交',
                    type: 'error'
                });
            }
            let data = {
                userName: this.userName,
                userEmail: this.userEmail,
                userPhone: this.userPhone,
            }
            try {
                if (this.index == false)
                    this.index = true
                // await postWebBusiness(data)
                this.$message({
                    message: '提交成功',
                    type: 'success'
                });
                this.userName = ''
                this.userEmail = ''
                this.userPhone = ''
                this.index = false
            } catch (e) {
                this.index = false
            }

        }
    }
}
</script>
<style scoped>
.page_tob_d {
    width: 100%;
    height: 26.8rem;
    background: #131316;
}

.page_footer_wd {
    width: 63rem;
    height: 18rem;
    color: #fff;
    margin-left: 5%;
    padding-top: 3rem;
}
.page_image{
    width: 10.25rem;
    height: 10.25rem;
    object-fit: cover;
}
.page_chat{
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 2rem;
}
.page_userPhone{
    margin-top: 8rem;
    display: flex;
    justify-content: space-between;
    align-items: end;
}
.page_de_mbt{
    margin-bottom: 1.2rem;
}
.page_de_mbr{
    margin-bottom: 0.4rem;
}
.page_size{
    font-size: 0.8rem;
}
.chat_right{
    margin-right: 6rem;
}
</style>
